export const toollist =  [
    {
        "Type": "Button",
        "Label": "Valider",
        "Color": "basic",
        "Icon": "done",
        "Method": "control"
    },
    {
        "Type": "Button",
        "Label": "Annuler",
        "Color": "warn",
        "Icon": "cancel",
        "Method": "cancel"
    }
];